
import GraficosVendas from "@/components/GraficosVendas";

export default {
  name: "VendasPorPeriodo",
  components: {
    GraficosVendas,
  },
  data: () => ({
    relatorio: [],
    headers: {
      dadosPorVendedor: [
        { text: "Vendedor", value: "vendedor" },
        { text: "Vendas", value: "quantidadeDeVendas" },
        { text: "Valor Total", value: "valorTotal" },
      ],
      relatorio: [
        { text: "ID", value: "id" },
        { text: "Vendedor", value: "nome_vendedor" },
        { text: "Isento", value: "insento_adesao" },
        { text: "Pagamento", value: "forma_pagamento_adesao" },
        { text: "Valor", value: "valor_adesao" },
        { text: "Plano", value: "nome_plano" },
      ],
    },
    dates: [],
  }),
  computed: {
    listaDeVendedores() {
      let vendedores = this.relatorio.map((i) => i.nome_vendedor);
      if (vendedores.length) {
        return new Set(vendedores);
      } else {
        return [];
      }
    },
    totalVendas() {
      return this.relatorio.length
        ? this.relatorio.map((i) => i.valor_adesao).reduce((a, c) => a + c)
        : null;
    },
    dadosPorVendedor() {
      let vendedores = Array.from(this.listaDeVendedores);
      return vendedores.map((vendedor) => {
        let quantidadeDeVendas = this.relatorio.filter(
          (i) => i.nome_vendedor == vendedor
        ).length;
        let valorTotal = this.relatorio
          .filter((i) => i.nome_vendedor == vendedor)
          .map((i) => i.valor_adesao)
          .reduce((a, c) => a + c);
        return {
          vendedor,
          quantidadeDeVendas,
          valorTotal,
        };
      });
    },
  },
  methods: {
    getRelatorio() {
      let i = this.dates[0].split("-");
      let f = this.dates[1].split("-");
      this.$http
        .get(
          `/relatorio/vendas/por-periodo/${i[2]}-${i[1]}-${i[0]}/${f[2]}-${f[1]}-${f[0]}`
        )
        .then((response) => (this.relatorio = response.data))
        .catch(() => this.$toast.open("Ocorreu um erro ao buscar o relatório"));
    },
  },

  watch: {
    dates(value) {
      if (value.length == 2) {
        this.getRelatorio();
      }
    },
  },

  filters: {
    dinheiro(value) {
      let dinheiro = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return dinheiro.format(value);
    },
  },
};
